<template>
  <timeline-list>
    <referral-application-timeline-item
      v-for="(item, index) in config"
      :key="index"
      :props="getProps(item, index)">
      <referral-application-stage slot="content" :item="item.content" :referee-name="refereeName" />
    </referral-application-timeline-item>
  </timeline-list>
</template>

<script>

import TimelineList from 'top20common/components/timeline/TimelineList';

import ReferralApplicationStage from '../application/ReferralApplicationStage';
import ReferralApplicationTimelineItem from './ReferralApplicationTimelineItem';

export default {
  props: {
    config: Array,
    refereeName: String
  },
  methods: {
    getProps(item, index) {
      return {
        markerColor: item.badge.markerColor,
        lineColor: item.badge.lineColor,
        isFilled: item.badge.isFilled,
        isLast: index === this.config.length - 1
      };
    }
  },
  components: {
    TimelineList,
    ReferralApplicationTimelineItem,
    ReferralApplicationStage
  }
};
</script>
